var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9215 17.398L38.9188 17.3953L22.602 1.07914C21.9064 0.383203 20.9817 0 19.9982 0C19.0146 0 18.0899 0.382969 17.3942 1.07883L1.0858 17.3867C1.08034 17.3922 1.07487 17.398 1.0694 17.4035C-0.358884 18.8399 -0.356384 21.1705 1.07643 22.6034C1.73096 23.2583 2.59557 23.6376 3.51994 23.6773C3.55744 23.6809 3.59534 23.6827 3.63346 23.6827H4.28377V35.6905C4.28377 38.0667 6.21705 40 8.59377 40H14.9774C15.6244 40 16.1492 39.4754 16.1492 38.8281V29.4141C16.1492 28.3298 17.0313 27.4478 18.1156 27.4478H21.8808C22.9652 27.4478 23.8471 28.3298 23.8471 29.4141V38.8281C23.8471 39.4754 24.3717 40 25.0189 40H31.4026C33.7793 40 35.7126 38.0667 35.7126 35.6906V23.6828H36.3156C37.2989 23.6828 38.2236 23.2998 38.9197 22.6041C40.3541 21.1688 40.3546 18.8342 38.9215 17.398Z",
    fill: "#F8821B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImg);
export default __webpack_public_path__ + "static/media/home-img.f53dfccc0f695b506a8e77d373ab7ba9.svg";
export { ForwardRef as ReactComponent };